import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { DesignProvider } from "./state/designStore";
import { AppErrorBoundary } from "./components/AppErrorBoundary";
import { SubscriptionGate } from "./components/SubscriptionGate";
import { bootstrapTelegram } from "./lib/telegram";
import { installKeyboardViewportFix } from "./lib/viewportFix";
import { installPerfMode } from "./lib/perf";
import "./styles.css";
import { hideSplash } from "./lib/splash";

bootstrapTelegram();
installKeyboardViewportFix();
installPerfMode();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <SubscriptionGate>
        <DesignProvider>
          <App />
        </DesignProvider>
      </SubscriptionGate>
    </AppErrorBoundary>
  </React.StrictMode>,
);

hideSplash();
